import { PAGE_CODES } from './pageCodes';

export const COMPOSED_CLAIMS = {
  INTERNAL_AUTH_IMPERSONATE: `${PAGE_CODES.INTERNAL_AUTH}.impersonate`,
  DOCUMENTS_GENERATE_BUNDLE: `${PAGE_CODES.DOCUMENTS}.generateBundle`,
  FORM_BUNDLE_DRAFT_ACCESS: `${PAGE_CODES.FORM_BUNDLE}.draftAccess`,
  LOAN_APPLICATION_SAVE_OTHER_USER_CHANGES: `${PAGE_CODES.LOAN_APPLICATION}.saveOthersUsersChanges`,
  LOAN_APPLICATION_CREATE_TEST_LOAN: `${PAGE_CODES.LOAN_APPLICATION}.createTestLoan`,
  LOAN_APPLICATION_EDIT_PMI: `${PAGE_CODES.LOAN_APPLICATION}.editPmi`,
  LOAN_APPLICATION_EDIT_LENDER_CREDIT: `${PAGE_CODES.LOAN_APPLICATION}.editLenderCredit`,
  LOAN_APPLICATION_RUN_AUS: `${PAGE_CODES.LOAN_APPLICATION}.runAus`,
  LOAN_APPLICATION_VIEW_LOG: `${PAGE_CODES.LOAN_APPLICATION}.viewLog`,
  LOAN_APPLICATION_CHANGE_PROGRAM: `${PAGE_CODES.LOAN_APPLICATION}.changeProgramOrRate`,
  LOAN_APPLICATION_SAVE_WITHOUT_PROGRAM: `${PAGE_CODES.LOAN_APPLICATION}.saveWithoutProgram`,
  LOAN_APPLICATION_COPY_LOAN: `${PAGE_CODES.LOAN_APPLICATION}.copyLoan`,
  LOAN_APPLICATION_ACTIVITIES: `${PAGE_CODES.LOAN_APPLICATION}.loanActivities`,
  LOAN_APPLICATION_CALLS: `${PAGE_CODES.LOAN_APPLICATION}.loanActivities.manageCalls`,
  LOAN_APPLICATION_CHAT: `${PAGE_CODES.LOAN_APPLICATION}.loanActivities.chats`,
  // tpoChat.* is its own claim vocabulary owned by the Skynet.Notifications domain (DEV-4223 Sub 1),
  // granted via a separate Accounts migration (Sub 2) — not a LOAN_APPLICATION page-code sub-claim.
  TPO_CHAT_VIEW: 'tpoChat.view',
  TPO_CHAT_ESCALATE: 'tpoChat.escalate',
  AUDIT_VIEW: 'audit.view',
  LOAN_APPLICATION_EDIT_LEADS: `${PAGE_CODES.LOAN_APPLICATION}.editLeads`,
  LOAN_APPLICATION_SWITCH_AUS_TYPE: `${PAGE_CODES.LOAN_APPLICATION}.switchAus`,
  LOAN_APPLICATION_EDIT_INVESTOR_CODE: `${PAGE_CODES.LOAN_APPLICATION}.editInvestorCode`,
  LOAN_CONDITIONS_MANUALLY_SIGN_OFF: `${PAGE_CODES.LOAN_CONDITIONS}.signOff`,
  LOAN_CONDITIONS_OWN_SIGN_OFF: `${PAGE_CODES.LOAN_CONDITIONS}.canSignOffOwnCondition`,
  LOAN_CONDITIONS_UNSIGN_OFF: `${PAGE_CODES.LOAN_CONDITIONS}.unsignOff`,
  LOAN_CONDITIONS_REJECT: `${PAGE_CODES.LOAN_CONDITIONS}.reject`,
  LOAN_CONDITIONS_OWN_REJECT: `${PAGE_CODES.LOAN_CONDITIONS}.canRejectOwnCondition`,
  LOAN_CONDITIONS_ADHOC_CREATE: `${PAGE_CODES.LOAN_CONDITIONS}.adhocCreate`,
  USERS_RESET_PASSWORD: `${PAGE_CODES.USERS}.resetPassword`,
  USERS_IMPERSONATE: `${PAGE_CODES.USERS}.impersonate`,
  USERS_VIEW_APPLICATION_LINK_IN_PROFILE: `${PAGE_CODES.USERS}.viewApplicationLinkInProfile`,
  LOCK_EXTENSIONS_OVERRIDE: `${PAGE_CODES.LOCK_EXTENSIONS}.override`,
  CUBE_HISTORY_OWN: `${PAGE_CODES.CUBE_HISTORY}.own`,
  CUBE_HISTORY_ALL_USERS: `${PAGE_CODES.CUBE_HISTORY}.allUsers`,
  APPROVE_REJECT_CANCEL_TASK: `${PAGE_CODES.TASKS}.approveRejectCancel`,
  UPDATE_STATUS_TASK: `${PAGE_CODES.TASKS}.updateStatus`,
  TASKS_VIEW_SUB_COMPANY: `${PAGE_CODES.TASKS}.viewSubCompany`,
  COMPANY_CENTER_VIEW_ALL: `${PAGE_CODES.COMPANY_CENTER}.viewAll`,
  COMPANY_CENTER_VIEW_OWN: `${PAGE_CODES.COMPANY_CENTER}.viewOwn`,
  COMPANY_AUS_SETTINGS_EDIT: `${PAGE_CODES.COMPANY_AUS_SETTINGS}.edit`,
  INTERNAL_COMPANY_AUS_SETTINGS_EDIT: `${PAGE_CODES.INTERNAL_COMPANY_AUS_SETTINGS}.edit`,
  UPLOAD_TO_TASK: `${PAGE_CODES.TASKS}.uploadToBorrowerTask`,
  MANUAL_LEAD_CREATION: 'manualLeadCreation.access',
  MANUAL_LEAD_CREATION_SELECT_SUB_COMPANY: 'manualLeadCreation.selectSubCompany',
  LOAN_EDITOR_EDIT_FEE_TYPE_NAME: `${PAGE_CODES.LOAN_FEES}.editFeeName`,
  LOAN_EDITOR_EDIT_FEE_PROVIDER_NAME: `${PAGE_CODES.LOAN_FEES}.editFeeProviderName`,
  LOAN_EDITOR_MANAGE_DISCOUNT_POINTS: `${PAGE_CODES.LOAN_FEES}.manageDiscountPoints`,
  LOAN_FEES_OVERRIDE_SUB_PROVIDER: `${PAGE_CODES.LOAN_FEES}.overrideSubProvider`,
  LOAN_EDITOR_EDIT_LOCK_INFO_FIELDS: `${PAGE_CODES.LOAN_LOCK_INFO}.editLockInfoFields`,
  VIEW_MARKUP_LEVELS: `${PAGE_CODES.LOAN_LOCK_INFO}.viewMarkupLevels`,
  LOAN_PIPELINES_IMPORT_MISMO: `${PAGE_CODES.PIPELINE_LOAN_VIEW}.importMISMO`,
  LOAN_EDITOR_EDIT_LOAN_PROGRAM: `${PAGE_CODES.LOAN_APPLICATION}.editLoanProgram`,
  LOAN_EDITOR_EDIT_CIC_REASONS: `${PAGE_CODES.LOAN_APPLICATION}.cicReasons.edit`,
  TELEPHONY_ENABLED: 'telephony.enabled',
  NOTIFICATION_CENTER_ACCESS: 'notificationCenter.access',
  // Skynet.Pricing's FeedAdminPolicy.Access claim (FeedAdminClaims): Freddie feed administration.
  GSE_PRICING_FEED_ADMIN_ACCESS: 'gsePricingFeedAdmin.access',
  AI_PROCESSES_EXECUTE: `${PAGE_CODES.AI_PROCESSES}.execute`,
  AI_PROCESSES_EDIT: `${PAGE_CODES.AI_PROCESSES}.edit`,
  AI_PROCESSES_MANAGE: `${PAGE_CODES.AI_PROCESSES}.manage`,
  AI_VIEW_CONFIDENCE_SCORES: `${PAGE_CODES.AI_PROCESSES}.viewConfidenceScores`,
  CLOSING_PORTAL_MANAGE: `${PAGE_CODES.CLOSING_PORTAL}.manage`,
  FORM_DELIVERY_EDIT_GENERATED_OUTSIDE_DATES: `${PAGE_CODES.FORM_DELIVERY}.editGeneratedOutsideFormDelivery`,
};

export const AI_DOCUMENT_INTAKE_CLAIMS = [
  COMPOSED_CLAIMS.AI_PROCESSES_EDIT,
  COMPOSED_CLAIMS.AI_PROCESSES_MANAGE,
];
